import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceAppResource from "./WorkspaceAppResource";
import MortgageBalanceAppResource from "./MortgageBalanceAppResource";
import moment from "moment";
import Engine from "@milestoneslabs/milestones-js-engine/src/Engine";
import cloneDeep from "lodash/cloneDeep";
import forEach from "lodash/forEach";

export const LOAN_TYPE_MAIN = 'main';
export const LOAN_TYPE_SECOND = 'second';
export const LOAN_TYPE_HELOC = 'heloc';

export const LOAN_TYPES = [LOAN_TYPE_MAIN, LOAN_TYPE_SECOND, LOAN_TYPE_HELOC]

class PropertyMortgageAppResource extends AppResource {

    selfClone() {
        const resourceClass = Engine.appResourceClass(this._resourceType)
        let instance = new resourceClass({
            attributes: this.attributes
        }, this._fetched)
        instance.uuid = this.uuid;
        instance._dirty = {}
        instance._errors = null
        instance._fetched = true
        instance._original = cloneDeep(this.attributes)
        forEach(this.relations, (relation, relationName) => {
            if (instance._original === null) {
                instance._original = {}
            }
            instance.setRelation(relationName, relation)
            instance._original[relationName] = cloneDeep(instance.get(relationName))
        })

        return instance;
    }

    /**
     *
     * @param attributeName
     * @param attributeValue
     * @returns {moment.Moment|moment.Moment|number|*}
     */
    castAttribute(attributeName, attributeValue) {
        attributeValue = super.castAttribute(attributeName, attributeValue)

        if (attributeName === 'originationDate') {
            return moment(attributeValue)
        }

        return attributeValue;
    }


    /**
     * @returns {string}
     */
    appResourceType() {
        return 'property-mortgage';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'property/mortgages';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'workspaceUuid',
            'lenderName',
            'amount',
            'originationDate',
            'rate',
            'type',
            'term',
            'insurance',
            'lastUserBalance',
            'corelogicImportId',
            'corelogicImportMortgageField',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspace: WorkspaceAppResource,
            lastUserBalance: MortgageBalanceAppResource
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspace: 'workspaceUuid',
        };
    }

    validationRules() {
        return {
            workspaceUuid: {
                type: 'string',
                presence: !this?.exists ? {
                    allowEmpty: false,
                } : false
            },
            lenderName: {
                type: 'string',
                presence: !this?.exists ? {
                    allowEmpty: false,
                } : false
            },
            amount: {
                numericality: {
                    greaterThan: 0,
                },
                presence: this.exists ? {allowEmpty: false} : true,
            },
            originationDate: {
                momentDate: {
                    message: !this?.exists ? '^Loan start date can\'t be blank' : false,
                },
            },
            rate: {
                numericality: {
                    greaterThan: 0,
                    lessThanOrEqualTo: 100,
                },
                presence: !this?.exists,
            },
            type: {
                type: 'string',
                inclusion: LOAN_TYPES,
                presence: !this?.exists,
            },
            term: {
                numericality: {
                    onlyInteger: true,
                    greaterThan: 0,
                },
                presence: !this?.exists ? {
                    allowEmpty: false,
                } : false,
            },
            insurance: {
                numericality: {
                    onlyInteger: true,
                    greaterThan: 0,
                },
            },
            updatedByUser: {
                type: 'boolean',
            },
            corelogicImportId: {
                numericality: {
                    onlyInteger: true,
                    greaterThan: 0,
                },
            },
            corelogicImportMortgageField: {
                type: 'string',
            },
        }
    };
}

export default PropertyMortgageAppResource;
